import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/info/:code',
      name: 'InfoPage',
      component: () => import('../views/InfoPage.vue'),
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: () => import('../views/AboutPage.vue'),
    },
    {
      path: '/360studio1',
      name: '360 Studio1 Page',
      component: () => import('../views/360Studio1Page.vue'),
    },
    {
      path: '/360studio2',
      name: '360 Studio2 Page',
      component: () => import('../views/360Studio2Page.vue'),
    },
    {
      path: '/360studio3',
      name: '360 Studio3 Page',
      component: () => import('../views/360Studio3Page.vue'),
    },
  ],
})

export default router
